import {TSEinstellungenTagesschule} from '../TSEinstellungenTagesschule';
import {TSModulTagesschuleGroupHasAnmeldung} from './TSModulTagesschuleGroupHasAnmeldung';

export class AdminModelEinstellungTagesschuleHasAnmeldung extends TSEinstellungenTagesschule {
    modulTagesschuleGroups: TSModulTagesschuleGroupHasAnmeldung[];
}
